<template>
    <div class="page-layout blank contacts-manage">
        <div class="pr-3 pl-3" :class="{'pb-15':orderToShow == 'grid'}">
            <div class="d-flex flex-wrap justify-content-between align-items-center margin742">
                <!-- Breadcrumb Section and Header Button Section -->
                <div class="breadcrumbnew">
                    <span>Deals</span>
                    <a v-if="orderToShow == 'list'">List View</a>
                    <span v-if="orderToShow != 'list'" @click="dealsToShow('list')">List View</span>
                    <a v-if="orderToShow != 'list'">Deal Pipeline</a>  
                </div>
                <!-- <button v-if="orderToShow == 'list'" class="btn btn-new-primary btn-wide px-6 ml-3" @click="showListViewFilters()">
                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;">
                    Filter
                </button> -->
                <div class="d-flex mx-4" style="flex-grow: 1;position: relative;" v-if="orderToShow == 'list'">
                    <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                    <i v-if="search_deal_list !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearchs"></i>
                    <input ref="searchInput" class="w-100 placeholder-text" v-model="search_deal_list"  v-debounce:500ms="loadData" debounce-events="input" type="text" placeholder="Search by Deal Name,Contact Name,Customer Name" style="border-radius: 20px 20px 20px 20px; padding-left:30px;padding-right: 10px;height: 2.9em;">
                </div>
                <!-- <div class="d-flex mx-4" style="flex-grow: 1" v-if="orderToShow == 'grid'">
                    <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 6px 16px; height: 2.7em;"></i>
                    <input class="w-100" v-model="search_key"  v-debounce:500ms="loadData" debounce-events="input" type="text" placeholder="Search by Deal Name" style="border-radius: 0px 20px 20px 0px; padding-left: 10px; height: 2.9em;">
                </div> -->
                <div class="d-flex flex-wrap align-items-center">
                    <button v-if="orderToShow == 'list'" class="btn btn-new-primary btn-wide px-4" @click="dealsToShow('grid')">
                        <i class="icon icon-magnify icondefault" style="border-radius: 0; background: transparent;  font-size: 20px;"></i> Deals Pipeline
                    </button>
                    <!-- <div class="d-flex justify-content-center icon-div" >
                        <div class="d-flex justify-content-center align-items-center pointer icon-changes mt-2"  @click="dealsToShow('list')">
                            <img :src="isListActive ? '/static/images/deals-bars-blue.svg': '/static/images/deals-bars-grey.svg'" width="18">
                        </div>
                        <div class="d-flex justify-content-center align-items-center pointer icon-changes mt-2"  @click="dealsToShow('grid')">
                            <img :src="isGridActive ? '/static/images/deals-grid-blue.svg' : '/static/images/deals-grid-light.svg'" width="18">
                        </div>

                    </div> -->
                    <!-- <button class="btn btn-new-primary btn-wide px-6 ml-4">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px">
                        Export to CSV
                    </button> -->
                    <button class="btn btn-new-save btn-wide px-6 ml-4" v-if="userPermissions.deals.permitted_actions.create && orderToShow == 'list'" @click="CreateDeal()">
                        + Create Deal
                    </button>
                    <button type="button" class="btn btn-smm btn-default" v-if="orderToShow == 'grid' && $route.params.id == 'list'"
                        style="border-radius: 6px !important;background-color: #787E7C;color: #fff;" @click="dealsToShow('list')">
                        <i class="icon icon-arrow-left fs-16 text-white pr-1"></i>Back
                    </button>
                    <button type="button" class="btn btn-smm btn-default" v-if="orderToShow == 'grid' && $route.params.id == 'viewpipeline'"
                        style="border-radius: 6px !important;background-color: #787E7C;color: #fff;" @click="redirectToViewDeal()">
                        <i class="icon icon-arrow-left fs-16 text-white pr-1"></i>Back
                    </button>
                </div>
            </div>
            <!-- Filter Chips Section -->
            <div class="filterSelectedChips chips-width mb-3 mt-3" v-if="showFilterDataList.company_name.length || showFilterDataList.contact_name.length || showFilterDataList.deal_name.length || showFilterDataList.owner_name.length || showFilterDataList.territory.length || showFilterDataList.pipeline.length || showFilterDataList.status.length || showFilterDataList.amount">
                <div class="pull-right pointer resetChips mt-1 mr-1" @click="removeAllChips()"><i class="icon icon-close text-white fs-22"></i></div>
                <div class="d-flex align-items-center flex-wrap">
                <span class="font-weight-bold text-white p-2" v-show="showFilterDataList.company_name.length">Customer Name</span>
                <span  v-for="(name,company_index) in showFilterDataList.company_name" :key="company_index" >
                    <span class="filterChips" @click="removeChips(name,'company_name')">
                        {{name.customer_name}}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>
                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.contact_name.length">Contact Name</span>
                <span  v-for="(contact,contact_index) in showFilterDataList.contact_name" :key="contact_index">
                    <span class="filterChips" @click="removeChips(contact,'contact_name')">
                        {{contact.full_name}}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>
                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.deal_name.length">Deal Name</span>
                <span  v-for="(deal,deal_index) in showFilterDataList.deal_name" :key="deal_index">
                    <span class="custom__filter">
                        <span class="filterSelectedName"> {{deal.name}}</span>
                        <span class="custom__remove pointer" @click="removeChips(deal,'deal_name')">
                            <i class="icon icon-close fs-14"></i>
                        </span>
                    </span>
                    <!-- <span class="filterChips text-flow " @click="removeChips(deal,'deal_name')">

                        <i class="icon icon-close fs-14 text-data"></i>
                    </span> -->
                </span>
                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.owner_name.length"  >Owner Name</span>
                <span  v-for="(owner,owner_index) in showFilterDataList.owner_name" :key="owner_index">
                    <span class="filterChips" @click="removeChips(owner,'owner_name')">
                        {{owner.full_name}}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>
                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.territory.length"  >Territory Name</span>
                <span  v-for="(territory,territory_index) in showFilterDataList.territory" :key="territory_index">
                    <span class="filterChips" @click="removeChips(territory,'territory_name')">
                        {{territory.name}}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>
                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.pipeline.length" >Pipeline</span>
                <span  v-for="(pipeline,pipeline_index) in showFilterDataList.pipeline" :key="pipeline_index">
                    <span class="filterChips" @click="removeChips(pipeline,'pipeline_name')">
                        {{pipeline.pipeline_name}}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>

                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.status.length">Status</span>
                <span  v-for="(status,status_index) in showFilterDataList.status" :key="status_index">
                    <span class="filterChips" @click="removeChips(status,'status')">
                        {{status.stage_name.replace(/_/g, " ") }}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>
                <span  class="font-weight-bold text-white p-2" v-show="showFilterDataList.amount">Amount</span>
                <span v-if="showFilterDataList.amount">
                    <span class="filterChips" @click="removeChips(showFilterDataList.amount,'amount')">
                        {{showFilterDataList.amount}}
                        <i class="icon icon-close fs-14"></i>
                    </span>
                </span>
            </div>
            </div>
            <!-- Deal Information Section -->
            <div class="start-overflow" v-if="orderToShow=='grid'">
                <div class="create-company-container w-100 ">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-3 text-white ml-3">Deal Information</span>
                            <!-- <span class="pointer mt-2">
                                <i class="icon-chevron-double-down text-white" style="font-size: 20px;"></i>
                            </span> -->

                        </div>
                        <div class="d-flex justify-content-between align-items-center px-8" style="flex-wrap:wrap;">
                            <div>
                                <multiselect
                                    :class="{'active-deals': selected_status == 'Active', 'closed': selected_status == 'Closed', 'archive': selected_status == 'Archive'}"
                                    v-validate="'required'" class="diginew-multiselect text-capitalize mt-2 deals-arrow-color"
                                    v-model="selected_status" name="status" :searchable="true" :options="status_options"
                                    placeholder="Select Deal">
                                </multiselect>
                            </div>
                            <div class="d-flex">
                                <button v-if="selected_status == 'Active' && userPermissions.deals.permitted_actions.archive" :disabled="selectedIds.length < 1" @click="archiveConfirm()" class="btn btn-new-primary btn-wide px-6" ><i class="icon icon-arrow-down-bold-box text-white mr-2 fs-18"></i>Archive</button>
                                <button v-if="selected_status != 'Closed' && userPermissions.deals.permitted_actions.delete" :disabled="selectedIds.length < 1" @click="deleteDeals" class="btn btn-danger text-whte btn-wide ml-3 px-6">- Delete</button>
                                <button v-if="selected_status == 'Archive' && userPermissions.deals.permitted_actions.retrieve" :disabled="selectedIds.length < 1" @click="retriveConfirm()" class="btn btn-new-save btn-wide px-6  ml-3" ><i class="icon icon-send icon-direction text-white mr-2 fs-14"></i><span class="ml-2">Send to Active Deal</span></button>
                                <button :disabled="deal_pipeline_name == null && assigned_territory == null" class="btn btn-new-primary btn-wide px-6 ml-3" @click="showFilters()">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;">
                                    Filter
                                </button>
                            </div>
                        </div>
                        <div class="row px-8">
                            <div v-if="deals_from == 'contacts'" class="col-lg-4 col-md-6 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-2 text-secondary">
                                    Contact Name
                                </span>
                                <div class="d-flex align-items-center">
                                    <multiselect
                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                        name="contact_name" @close="loadDeals()" @select="contactNameSelected($event)" label="full_name" :loading="contact_loading" v-model="contact_name"
                                        :options="contact_name_options" @search-change="searchContactName" :searchable="true" :max-height="200"
                                        v-validate="'required'" placeholder="Select Contact Name">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Contact Name Not Found</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfContactName"/>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('contact_name')">Contact Name is Required</span>
                            </div>
                            <div v-if="deals_from == 'customers'" class="col-lg-4 col-md-6 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-2 text-secondary">
                                    Customer Name
                                </span>
                                <div class="d-flex align-items-center">
                                    <multiselect
                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                        name="customer_name" @close="loadDeals()" @select="customerNameSelected($event)" label="customer_name" :loading="customer_loading" v-model="customer_name"
                                        :options="customer_name_options" @search-change="searchCustomerName" :searchable="true" :max-height="200"
                                        v-validate="'required'" placeholder="Select Customer Name">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Contact Name Not Found</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfCustomerName"/>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('customer_name')">Customer Name is Required</span>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-2 text-secondary">
                                    Deal Pipeline Name
                                </span>
                                <div class="d-flex align-items-center">
                                    <multiselect
                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                        name="deal_pipeline_name" @close="loadDeals()" @search-change="searchPipelines" label="pipeline_name" :loading="pipeline_loading" v-model="deal_pipeline_name"
                                        :options="deals_pipeline_options" :show-selected="true" :searchable="true" :max-height="200"
                                        v-validate="'required'" placeholder="Select Deal Pipeline Name">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Deal Pipelines Not Found</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfPipelines" />
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('deal_pipeline_name')">Deal Pipeline Name is Required</span>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-2 text-secondary">
                                    Assigned Territory
                                </span>
                                <div class="d-flex align-items-center">
                                    <multiselect
                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                        name="assigned_territory" @close="loadDeals()" v-model="assigned_territory"
                                        :options="territory_list" :show-selected="true" :disabled="deal_pipeline_name == null" :loading="territories_loading" label="name" :searchable="true" :max-height="200"
                                        placeholder="Select Territory">
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Assigned Territories Not Found
                                            </div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfTerritoryList" />
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('assigned_territory')">{{errors.first('assigned_territory')}}</span>
                            </div>
                        </div>
                        <div class="row px-8 py-5">
                            <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                                <div class=" d-flex justify-content-between header-text-heading fs-14 fw-500 text-white px-2 py-3">Stages</div>
                            </div>
                        </div>
                        <div class="px-8" v-if="deal_pipeline_name || assigned_territory">
                            <div v-if="ajax_call_in_progress">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </div>
                            <div class="fs-14 fw-600 text-center mt-12" v-if="!ajax_call_in_progress && deal_list.length == 0">
                                No Data
                            </div>
                            <div v-else class="d-flex" style="flex-wrap:wrap">
                                <div class="w-25" v-for="(list,index) in deal_list" :key="index">
                                    <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                        {{list.stage_name.replace("_", " ")}} ({{list.probability}}%)
                                    </span>
                                    <div>
                                        <div @dragenter="dropData($event,list)" :id="'drop_id'+index" @dragenter.prevent @dragover="dragOverHandle($event)" @drop="droppedData($event,list, index)" class="bord-blue bordradtlr-5px mt-5 pb-2" style="min-height: 350px;max-height:200px;overflow: auto;">
                                            <div class="fs-14 fw-600 text-center mt-12" v-if="list.deals.length == 0 && !is_deal_moving">
                                                No Data
                                            </div>
                                            <div v-else class="d-flex flex-column p-2 mt-2 mx-2"
                                                :id="deal.id" v-for="(deal,deal_index) in list.deals"
                                                :key="deal_index"
                                                :draggable="selected_status == 'Active'"
                                                @dragstart="startDrag($event,list,deal)"
                                                style="box-shadow: 0 0 6px 0 #939393;"
                                            >
                                                <!-- :draggable="selected_status == 'Active' && !(list.stage_name.replace('_', ' ') == 'Deal Won' || list.stage_name.replace('_', ' ') == 'deal won' || list.stage_name.replace('_', ' ') == 'Deal Lost' || list.stage_name.replace('_', ' ') == 'deal lost')" -->
                                                <div class="d-flex justify-content-between">
                                                    <div class="d-flex flex-column justify-content-between">
                                                        <div class="d-flex">
                                                            <div v-if ="selected_status == 'Closed' && is_true">
                                                                <label  class="custom-control custom-checkbox digi-checkbox" style="display:none!important;">
                                                                    <input  type="checkbox" class="custom-control-input" @click="singleSelect(deal)" v-model="selectedIds" :value="deal.id" />
                                                                    <span  class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                                                    <span class="form-check-description fw-600"></span>
                                                                </label>
                                                            </div>
                                                            <div v-else>
                                                                <label class="custom-control custom-checkbox digi-checkbox" >
                                                                    <input  type="checkbox" class="custom-control-input" @click="singleSelect(deal)" v-model="selectedIds" :value="deal.id" />
                                                                    <span  class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                                                    <span class="form-check-description fw-600"></span>
                                                                </label>
                                                            </div>
                                                            <span class="fs-12 fw-600 pointer text-secondary" style="word-break:break-all;" @click="DealDetails(deal)">
                                                                    {{deal.name}}
                                                            </span>
                                                        </div>
                                                        <span class="fs-12 fw-500">
                                                            Customer Name : {{deal.customer_name || '-'}}
                                                        </span>
                                                        <span class="fs-12 fw-500">
                                                            Contact Name : {{deal.contact_name || '-'}}
                                                        </span>
                                                        <span class="fs-12 fw-500">
                                                            Amount ({{currency}}) : {{deal.total_transaction_value || '-'}}
                                                        </span>
                                                        <span class="fs-12 fw-500">
                                                            Expected Date : {{deal.expected_close_date || '-'}}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex flex-column justify-content-between" >
                                                        <el-dropdown v-model="move_to" trigger="click" :class="{'move-to-visible':selected_status != 'Active'}">
                                                            <span class="d-flex pl-2 pr-2 move-to">
                                                                Move to
                                                                <div style="width: 100%">
                                                                    <i class="icon icon-chevron-right icon-chevron-right-menubar float-right"></i>
                                                                </div>
                                                            </span>
                                                            <el-dropdown-menu slot="dropdown">
                                                                <el-dropdown-item v-for="(deal_data,list_index) in deal_list" :key="list_index" @click.native="moveStage(deal_data.id, deal)">
                                                                    <span v-if="list.stage_name != deal_data.stage_name" class="text-capitalize">{{deal_data.stage_name.replace('_', ' ')}}</span>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                        <el-dropdown v-model="priority" trigger="click" class="text-right" >
                                                            <i class="icon icon-circle fs-20 text-right " :class="{'text-dark-red': deal.priority == 'high', 'text-medium-status': deal.priority == 'medium', 'text-low-status': deal.priority == 'low'}"></i>
                                                            <el-dropdown-menu slot="dropdown" class="priority-cursor">
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-dark-red">High</span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-medium-status">Medium</span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-low-status">Low</span>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-2 d-flex justify-content-between bordradblr-5px" style="background-color: #00448b;">
                                            <span class="fs-12 fw-600 text-white">
                                                Total ({{currency}})
                                            </span>
                                            <span class="fs-12 fw-600 text-white">
                                                {{list.total}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="d-flex justify-content-center">
                                <div class="d-flex flex-column">
                                    <img src="/static/images/images-new-theme/search-deal-image.png" alt="">
                                    <p class="mt-4 text-secondary text-center fw-500 fs-14">Select Deal Pipeline and Territory to display Deals!!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="display_filters && orderToShow == 'grid'" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <!-- <filter-data :showFilterDataList="showFilterDataList" @hideFilters="hideFilters" @UpdateByFilterList="UpdateByFilterList" ></filter-data> -->
                <filter-data-list orderToShow='grid' :showFilterDataList="showFilterDataList" @hideFilters="hideFilters" :deal_pipeline_id="deal_pipeline_name" @UpdateByFilterList="UpdateByFilterList"></filter-data-list>
            </div>
        </div>
        <archive-modal modal_name="archiveModal" @archiveData="archiveData" @cancelArchive="cancelArchive" :active_status="'Retrieve'"></archive-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <add-product @hide-add-product="hideAddProductModal" v-if="add_product" modal_name="Add-Product"></add-product>
        <add-notes v-if="add_notes" @hide-notes-modal="HideNotes" modal_name="Add-Notes"></add-notes>
        <list-deals v-if="orderToShow=='list'" orderToShow='list' @selectedData="selectedData" @updatedShowFilters="updatedShowFilters" @hide-list-deals="hideListDeals" @clearSearch="clearSearch"></list-deals>
    </div>
</template>

<script>
    const FilterData = () => import('./FilterData');
    const FilterDataList = () => import('./FilterDataList');
    const Archive = () => import('./Archive');
    const ListDeals = () => import('./ListDeals');
    const ActiveDeal = () => import('./ActiveDeal');
    import ArchiveModal from "../alertModals/ArchiveModal";
    const Closed = () => import('./Closed')
    import { EventBus } from '../eventBus/nav-bar-event';
    import pipeline_lazy_loading from "../mixins/pipeline_lazyloading";
    import deals from "../mixins/deals";
    import { SweetModal } from 'sweet-modal-vue';
    // import territory_lazy_loading from "../mixins/territory_lazy_loading";
    import contacts from '../mixins/contacts';
    import customer from '../mixins/customer';
    import { HalfCircleSpinner } from "epic-spinners";
    import { debounce } from 'lodash'
    export default {
        data() {
            return {
                success_msg: "",
                move_to: null,
                warning_msg: "",
                customer_name: '',
                contact_name_options: [],
                customer_name_options: [],
                deal_pipeline_name: null,
                assigned_territory: null,
                selected_status: 'Active',
                status_options: ['Active', 'Archive', 'Closed'],
                hide_filters: false,
                display_filters: false,
                hide_list_filters: false,
                display_list_filters: false,
                selectedIds: [],
                is_true :false,
                add_notes: false,
                add_product: false,
                pipeline_loading:false,
                priority: 'high',
                deal_list: null,
                search_key: "",
                showFilterData: {
                    contact_name:[],
                    company_name:[],
                    deal_name: [],
                    territory:[],
                    owner_name:[],
                    pipeline:[],
                },
                showFilterDataList: {
                    contact_name:[],
                    company_name:[],
                    deal_name: [],
                    territory:[],
                    owner_name:[],
                    pipeline:[],
                    status: [],
                    total_amount:'',
                },
                filter_json:{
                    contact_id: [],
                    deal_id: [],
                    customer_id: [],
                    territory_id:[],
                    owner_id:[],
                    pipeline_id:[],
                    status: [],
                    total_amount:'',
                },
                contact_loading: false,
                contact_name: '',
                contact_name_options: [],
                contact_name_scrollable: false,
                contact_name_count: 0,
                temp_contacts: [],
                customer_loading: false,
                customer_name: '',
                customer_name_options: [],
                customer_name_scrollable: false,
                customer_name_count: 0,
                temp_customers: [],
                territories_loading: false,
                temp_territories: [],
                territory_count: 0,
                territory_scrollable: false,
                territories_visible: false,
                territory_list: [],
                deals_from: '',
                currency : '',
                deal_stage:[],
                deal_stage_id :'',
                ajax_call_in_progress: false,
                is_deal_moving: false,
                orderToShow: "list",
                isGridActive: false,
                isListActive: true,
                search_deal_list:''
            }
        },
        mixins:[pipeline_lazy_loading,deals,contacts, customer],
        components: {
            SweetModal,
            FilterData,
            Archive,
            ActiveDeal,
            Closed,
            ArchiveModal,
            HalfCircleSpinner,
            ListDeals,
            FilterDataList
        },
        methods: {
            clearSearchs(){
                this.search_deal_list = ""
                this.$refs.searchInput.focus();
                this.loadData();
            },
            redirectToViewDeal(){
                let deal_id = localStorage.getItem("deal_id")
                this.$router.push(`/deals/dealdetails/` + deal_id)
            },
            //load the list data
            loadData(){
                if(this.orderToShow == "list"){
                    this.loadDealsList();
                }else{
                    this.loadDeals();
                }
            },
            //update the show filters
            /**@params = value */
            updatedShowFilters(value){
                this.showFilterDataList = value
            },
            //clear the search
            clearSearch() {
                this.search_deal_list = ""
            },
            //hide list deals
            hideListDeals() {
                this.isListActive = false
                this.isGridActive = true
            },
            //get the selected data
            /**@params = value */
            selectedData(value){
                this.selected_data = value
            },
            startDrag(evt, list, deal) {
                evt.dataTransfer.setData("text", evt.target.id);
                evt.dataTransfer.effectAllowed = "move";
            },
            //To show the deals grid/list view
            /**@params = value */
            dealsToShow(value) {
                this.deal_pipeline_name = null;
                this.assigned_territory = null;
                this.search_deal_list = '';
                if(value== 'grid') {
                    this.orderToShow = value
                    this.isGridActive = true
                    this.isListActive = false
                    EventBus.$emit("tab_status",'grid')
                    this.removeAllChips()
                } else{
                    this.orderToShow = value
                    this.isListActive = true
                    this.isGridActive = false
                    EventBus.$emit("tab_status",'grid')
                    this.removeAllChips()
                }
            },
            droppedData(e, list, index) {
                // let data = JSON.parse(e.dataTransfer.getData('text/plain'))
                // list.deals.push(data)
                e.preventDefault();
                // Get the id of the target and add the moved element to the target's DOM
                if(this.selected_status == 'Active'){
                    this.is_deal_moving = true;
                    var data = e.dataTransfer.getData("text");
                    let deal_id = {
                        id: data
                    }
                    // e.target.appendChild(document.getElementById(data));
                    this.moveStage(list.id, deal_id);
                    this.$forceUpdate()
                }
                else if(this.selected_status == 'Archive'){
                    this.warning_msg = "Archive deals cannot be moved to other stages";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 6000);
                }
                else if(this.selected_status == 'Closed'){
                    this.warning_msg = "Closed deals cannot be moved to other stages";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 6000);
                }
            },
            //Api call to search territory
            /**@params = territory */
            async searchTerritory(territory) {
                this.territories_loading = true
                let response = await this.Listterritory_list({
                    search_key: territory
                })
                this.territory_list = response.response
                this.territory_list = this.territory_list.filter(x => {
                    if (x.name) {
                        return x
                    }
                })
                this.territory_count = this.territory_list.length
                this.territories_loading = false
                this.territory_scrollable = false
            },
            //Lazy loading of the terriotory list
            /**@params = reached */
            async reachedEndOfTerritoryList(reached) {
                this.territories_visible = reached
                if (reached) {
                    if (this.territory_scrollable == false) {
                        this.territories_loading = true
                        /**@params = skip, @params = limit, @parmas = hierarchy_level */
                        let response = await this.getTerritoryListFilter({
                            skip: this.territory_count,
                            limit: 10,
                            hierarchy_level: 'all'
                        })
                        this.temp_territories = response.response.length;
                        if (response.skip == this.territory_count) {
                            if (this.temp_territories > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.territory_list.push(el);
                                    this.territory_list = this.territory_list.filter(x => {
                                        if (x.name) {
                                            return x
                                        }
                                    })
                                });
                                this.territory_count += response.response.length;
                                this.territories_loading = false
                            } else {
                                this.territory_scrollable = true
                                this.territories_loading = false
                            }
                        }
                        this.territories_loading = false
                    }
                }
            },
            dragOverHandle(ev) {
                ev.preventDefault();
                // Set the dropEffect to move
                ev.dataTransfer.dropEffect = "move"
            },
            dropData(e, list) {
                e.preventDefault()
            },
            //retirve from archive status confirm
            retriveConfirm() {
                EventBus.$emit("archive_status",'retrieve')
                this.$modal.show('archiveModal')
            },
            //archive status confirm
            archiveConfirm() {
                EventBus.$emit("archive_status",'archive')
                this.$modal.show('archiveModal')
            },
            //cancel archive
            cancelArchive(){
                this.selectedIds = []
            },
            //get the archive data
            async archiveData(){
                let params = {
                    id: this.selectedIds
                }
                //Api call based on the selected status
                if(this.selected_status == 'Active'){
                    let response = await this.moveDeals(this.selected_status == 'Active'?'archive':'active',params)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.selectedIds = [];
                        this.loadDeals();

                    }, 3000);
                }
                else if (this.selected_status == 'Archive') {
                    let response = await this.moveDeals(this.selected_status == 'Archive'?'active':'archive',params)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.selectedIds = [];
                        this.loadDeals();
                    }, 3000);
                }


            },
            //Api call to delete deals
            async deleteDeals() {
                let params = {
                    id: this.selectedIds
                }
                let response = await this.deleteDealsById('delete', params)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadDeals();
                }, 3000);
            },
            //select the priority based on the deals
            /**@params = obj*/
            SelectPriority(obj) {
                if (obj == 'high') {
                    this.priority = 'high'
                } else if (obj == 'medium') {
                    this.priority = 'medium'
                } else if (obj == 'low') {
                    this.priority = 'low'
                }
            },
            //get the details of the deal
            /**@params = deal */
            DealDetails(deal) {
                if(this.userPermissions.deals.permitted_actions.view){
                    this.$router.push({
                        name: "DealDetails",
                        path: '/deals/dealdetails',
                        params: {
                            id: deal.id,
                        }
                    });
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            //selection of the single data form the list
            /**@params = value */
            singleSelect(value) {
                if (this.selectedIds.find(x => x === value.id)) {
                    this.selectedIds = this.selectedIds.filter(function (x) {
                        if (x !== value.id) {
                            return x;
                        }
                    });
                } else {
                    this.selectedIds.push(value.id)
                }
                this.$emit('selected-id', this.selectedIds)
            },
            //hide filters
            hideFilters() {
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            },
            //show filters
            showFilters() {
                if (this.display_filters) {
                    this.hide_filters = true
                    setTimeout(() => {
                        this.display_filters = false
                        this.hide_filters = false
                    }, 500);
                } else {
                    this.display_filters = true
                }
            },
            //show the list view filters
            showListViewFilters() {
                if (this.display_list_filters) {
                    this.hide_list_filters = true
                    setTimeout(() => {
                        this.display_list_filters = false
                        this.hide_list_filters = false
                    }, 500);
                } else {
                    this.display_list_filters = true
                }
            },
            //hide the list view filters
            hideListViewFilters() {
                this.hide_list_filters = true
                setTimeout(() => {
                    this.display_list_filters = false
                    this.hide_list_filters = false
                }, 500);
            },
            //Set the priority
            /**@params = obj */
            SelectPriority(obj) {
                if (obj == 'high') {
                    this.priority = 'high'
                } else if (obj == 'medium') {
                    this.priority = 'medium'
                } else if (obj == 'low') {
                    this.priority = 'low'
                }
            },
            //create new deal
            CreateDeal() {
                localStorage.removeItem("deal_type")
                this.$router.push({
                    name: "CreateNewDeals",
                    params: {
                        id: "new"
                    }
                })
            },
            SelectedID(value) {
                this.selectedIds = value
            },
            //get the selected contact name
            /**@params = data  */
            contactNameSelected(data) {
                this.filter_json.customer_id = [data.id];
            },
            //API call  to get the searched contact name
            /**@params = contact_name */
            async searchContactNameDebouncer(contact_name){
                this.contact_loading = true
                let response = await this.getBusinessConatactList({
                    search_key: contact_name
                })
                this.contact_name_options = response.response
                this.contact_name_count = this.contact_name_options.length
                this.contact_loading = false
                this.contact_name_scrollable = false
            },
            //Lazy loading to get the contact name
            /**@params = reached */
            async reachedEndOfContactName(reached){
                this.contact_name_visible = reached
                if (reached) {
                    if (this.contact_name_scrollable == false) {
                        this.contact_loading = true
                        /**@params = skip, @params = limit, @params = search_key */
                        let response = await this.getBusinessConatactList({
                            skip: this.contact_name_count,
                            limit: 10,
                            search_key: ""
                        })
                        this.temp_contacts = response.response.length;
                        if (response.skip == this.contact_name_count) {
                            if (this.temp_contacts > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.contact_name_options.push(el);
                                });
                                this.contact_name_count += response.response.length;
                                this.contact_loading = false
                            } else {
                                this.contact_name_scrollable = true
                                this.contact_loading = false
                            }
                        }
                        this.contact_loading = false
                    }
                }
            },
            //get the selected customer name
            /**@params = data  */
            customerNameSelected(data) {
                this.filter_json.customer_id = [data.id];
            },
            //API call to get the search customer name
            /**@params = customer_name */
            async searchCustomerNameDebouncer(customer_name){
                this.customer_loading = true
                let response = await this.getCustomerList({
                    search_key: customer_name
                })
                this.customer_name_options = response.response
                this.customer_name_count = this.customer_name_options.length
                this.customer_loading = false
                this.customer_name_scrollable = false
            },
            //Lazy loading to get the customer name
            /**@params = reached */
            async reachedEndOfCustomerName(reached){
                this.customer_name_visible = reached
                if (reached) {
                    if (this.customer_name_scrollable == false) {
                        this.customer_loading = true
                        let response = await this.getCustomerList({
                            skip: this.customer_name_count,
                            limit: 10,
                            search_key: ""
                        })
                        this.temp_customers = response.response.length;
                        if (response.skip == this.customer_name_count) {
                            if (this.temp_customers > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.customer_name_options.push(el);
                                });
                                this.customer_name_count += response.response.length;
                                this.customer_loading = false
                            } else {
                                this.customer_name_scrollable = true
                                this.customer_loading = false
                            }
                        }
                        this.customer_loading = false
                    }
                }
            },
            //API call to load deals
            async loadDeals(){
                // if(this.deal_pipeline_name || this.assigned_territory){
                    this.deal_list = [];
                    this.is_deal_moving = false;
                    this.ajax_call_in_progress = true;
                    /**@params = deal_pipeline_id, @prams = status, @prams = search_key, @params = stage_id, @params = skip, @params = limit,@params = filter_json  */
                    let params = {
                        deal_pipeline_id: this.deal_pipeline_name.id,
                        status: this.selected_status == 'Active' ? "active" : this.selected_status == 'Archive' ? 'archive' : 'closed',
                        search_key: this.search_key,
                        stage_id: '',
                        skip: 0,
                        limit: 50,
                        filter_json: this.filter_json
                    }
                    // params.filter_json.deal_id = params.filter_json.deal_name;
                    // delete params.filter_json.deal_name;
                    if(this.assigned_territory){
                        params['territory_id'] = this.assigned_territory.id
                    }
                    let response = await this.getDealsList(params)
                    this.selectedIds = []
                    this.deal_list = response.response
                    this.deal_list.forEach((x)=> {
                        this.deal_stage = x.stage_name
                        this.deal_stage_id = x.stage_id
                        if(this.deal_stage == 'deal_won' || this.deal_stage == 'deal_lost'){
                            this.is_true = true
                        } else {
                            this.is_true = false
                        }
                    })
                    this.ajax_call_in_progress = false;
                    // this.deal_list.response.forEach(x => {
                    //     x.deals =
                    // })
                    // this.deal_list.response.forEach(x => {
                    //     x.deals = [
                    //         {
                    //             "expected_close_date": "2021-12-20",
                    //             "id": "61bdb94e9cddadbc798ce1b6",
                    //             "name": "Some Deal 8",
                    //             "priority": "high",
                    //             "total_transaction_value": 5000
                    //         },
                    //         {
                    //             "expected_close_date": "2021-12-20",
                    //             "id": "61bdb9529cddadbc798ce1b9",
                    //             "name": "Some Deal 9",
                    //             "priority": "high",
                    //             "total_transaction_value": 5000
                    //         }
                    //     ]
                    // })
                // }
            },
            removeChips(value,key){
                let params = {
                    value:value,
                    key:key
                }
                EventBus.$emit('removechip',params)
            },
            //update the filter list
            /**@params = params */
            UpdateByFilterList(params){
                this.skip = 0
                this.limit = 10
                this.showFilterDataList = {
                    company_name:params.value1.company_name,
                    contact_name:params.value1.contact_name,
                    deal_name:params.value1.deal_name,
                    territory:params.value1.territory,
                    owner_name:params.value1.owner_name,
                    pipeline:params.value1.pipeline,
                    status:params.value1.status,
                    amount:params.value1.amount
                }
                this.filter_json = {
                    customer_id:params.value.company_name,
                    contact_id:params.value.contact_name,
                    deal_id:params.value.deal_name,
                    territory_id:params.value.territory,
                    owner_id:params.value.owner_name,
                    pipeline_id:params.value.pipeline,
                    status:params.value.status,
                    amount:params.value.amount
                }
                this.display_filters = false
                this.loadDeals()
            },
            removeAllChips(){
                if(this.orderToShow == 'grid') {
                    this.filter_json = {
                        contact_id: [],
                        customer_id: [],
                        deal_id: [],
                        territory_id:[],
                        owner_id:[],
                        pipeline_id:[],
                        status: [],
                        total_amount:'',
                    }
                    this.showFilterData = {
                        company_name: [],
                        contact_name: [],
                        deal_name: [],
                        territory:[],
                        owner_name:[],
                        pipeline:[],
                        status: [],
                        total_amount:'',
                    }
                    EventBus.$emit('removeAllchip')
                } else {
                    this.filter_json ={
                        contact_id: [],
                        customer_id: [],
                        deal_id: [],
                        territory_id:[],
                        owner_id:[],
                        pipeline_id:[],
                        status: [],
                        total_amount:'',
                    }
                    this.showFilterDataList = {
                        company_name: [],
                        contact_name: [],
                        deal_name: [],
                        territory:[],
                        owner_name:[],
                        pipeline:[],
                        status: [],
                        total_amount:'',
                    }
                    EventBus.$emit('removeAllchip')
                }
            },
            //move the staged form one to other
            /**@params = stage_id, @params =deal_id */
            async moveStage(stage_id, deal_id){
                this.selectedIds = []
                /**@params = pipeline_id, @params =deal_id , @params = stage_id*/
                let params = {
                    pipeline_id: this.deal_pipeline_name.id,
                    deal_id: deal_id.id,
                    stage_id: stage_id
                }
                let response = await this.moveDealStage(params)
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.loadDeals()
                }, 3000);
            },
            //load the deal details
            loadDealsList() {
                EventBus.$emit("search_list_deals",this.search_deal_list)
            },

        },
        computed : {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            }
        },
        mounted(){
            this.currency = this.loggedInUser.currency.symbol;
            if(this.$route.params.id == 'list'){
                this.loadDeals();
            } else if(this.$route.params.id == 'viewpipeline'){
                let data = JSON.parse(localStorage.getItem("deal_pipeline_view"))
                this.dealsToShow('grid')
                this.deal_pipeline_name = {
                    pipeline_name: data.deal_pipeline,
                    id: data.deal_pipeline_id,
                };
                this.selected_status = data.deal_status[0].toUpperCase() + data.deal_status.substring(1)
                this.loadDeals();
            } else {
                let data = JSON.parse(localStorage.getItem("view_deal_from_cust"))
                if(data){
                    this.deals_from = data.deal_type
                    this.deal_pipeline_name = {
                        pipeline_name: data.value.deal_pipelines[0].pipeline_name,
                        id: data.value.deal_pipelines[0].deal_pipeline_id
                    };
                    if(data.deal_type == 'contacts') {
                        this.contact_name = {
                            full_name: data.value.full_name,
                            id: data.value.id
                        }
                        this.filter_json.contact_id = [data.value.id]
                    };
                    if(data.deal_type == 'customers') {
                        this.customer_name = {
                            customer_name: data.value.customer_name,
                            id: data.value.id
                        }
                        this.filter_json.customer_id = [data.value.id]
                    }
                }
                this.loadDeals();
            }
        },
        created(){
            this.searchContactName = debounce(this.searchContactNameDebouncer, 500)
            this.searchCustomerName = debounce(this.searchCustomerNameDebouncer, 500)
        },
        watch:{
            selected_status(){
                this.loadDeals()
            }
        }
    }
</script>
<style scoped>
    .dropdown-toggle:empty::after {
        display: none;
    }

    .w-25 {
        width: 24% !important;
        margin-right: 10px !important;
    }

    .decoration-none {
        text-decoration: none !important;
    }

    .text-dark-blue {
        color: #00448b;
    }

    .text-dark-red {
        color: #f80c17;
    }

    .text-medium-status {
        color: #ff9a35;
    }

    .text-low-status {
        color: #005dae;
    }

    .bord-blue {
        border: 1px solid #00448b !important;
    }

    .bordrad-5px {
        border-radius: 5px !important;
    }

    .bordradtlr-5px {
        border-radius: 5px 5px 0 0 !important;
    }

    .bordradblr-5px {
        border-radius: 0 0 5px 5px !important;
    }

    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }

    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #005dae;
    }

    .bordrad-5px {
        border-radius: 5px !important;
    }

    .header-text-heading {
        padding: 9.7px 22.2px;
        background-color: #005dae;
    }

    .scm-filters {
        width: 578px !important;
        max-height: 370px !important;
        right: 50px;
        overflow: auto !important;
        padding-bottom: 20px;
    }

    .icon-tick-success {
        color: #008a63;
    }

    .stage-sections {
        border: solid 1px #3f3f3f;
        border-radius: 4px;
        height: 350px;
        max-height: 350px;
        /* overflow: auto; */
    }

    .stage-sections .bg-blue {
        background-color: #00448b;
        color: #fff;
        font-weight: 500;
        padding: 10px;
    }

    .stage-sections-right {
        border: solid 1px #3f3f3f;
        border-radius: 4px;
        height: 712px;
        max-height: 712px;
        /* overflow: auto; */
    }

    .stage-sections-right .bg-blue {
        background-color: #00448b;
        color: #fff;
        font-weight: 500;
        padding: 10px;
    }

    .btn-secondary:hover {
        background-color: #00448b !important;
    }

    ul {
        list-style: none;
    }

    .drag-drop-grey-bg {
        background-color: #f5f5f5;
    }

    .drag-drop-white-bg {
        background-color: #fff;
    }

    .drag_drop_cond {
        color: rgba(103, 103, 103, 0.84)
    }

    @media screen and (max-width:992px) {
        .w-25 {
            width: 49% !important;
            margin-right: 10px !important;
        }
    }

    @media (max-width: 1300px) {
        .flex-width {
            max-width: 100% !important;
            width: 100% !important;
            flex: 0 0 100% !important;
            transition: 0.5s ease all;
        }
    }

    @media screen and (max-width:992px) {
        .stage-sections-right {
            height: 375px;
        }

        .prod-var-max-ht {
            max-height: 256px !important;
        }
    }
    .dropdown-toggle-deals:empty::after {
        display: none;
    }

    .w-25 {
        width: 24% !important;
        margin-right: 10px !important;
    }

    .decoration-none {
        text-decoration: none !important;
    }

    .text-dark-blue {
        color: #00448b;
    }

    .text-dark-red {
        color: #f80c17;
    }

    .text-medium-status {
        color: #ff9a35;
    }

    .text-low-status {
        color: #005dae;
    }

    .bord-blue {
        border: 1px solid #00448b !important;
    }

    .bordrad-5px {
        border-radius: 5px !important;
    }

    .bordradtlr-5px {
        border-radius: 5px 5px 0 0 !important;
    }

    .bordradblr-5px {
        border-radius: 0 0 5px 5px !important;
    }

    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }

    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #005dae;
    }

    .bordrad-5px {
        border-radius: 5px !important;
    }

    .header-text-heading {
        padding: 9.7px 22.2px;
        background-color: #005dae;
    }

    .icon-tick-success {
        color: #008a63;
    }

    .btn-secondary:hover {
        background-color: #00448b !important;
    }

    ul {
        list-style: none;
    }

    @media screen and (max-width:992px) {
        .w-25 {
            width: 48% !important;
            margin-right: 10px !important;
        }
    }

    .menuScroll-deals {
        text-decoration: none;
        color: #fff !important;
        position: relative;
        line-height: 2;
        height: 3.97rem !important;
        padding: 0px;
        margin-bottom: 0px;
    }

    .menuScroll-deals a {
        text-decoration: none;
        color: #000 !important;
        position: relative;
        line-height: 2;
        height: 3rem !important;
        padding: 0px;
    }

    .dropdown-toggle-deals::after {
        display: none;
    }

    .nav-link-deals i {
        margin-right: 0px;
    }

    .dropdown-menu.dropdown-width li:hover {
        background-color: #ecf1f9 !important;
        color: #00448b !important;
    }
    .move-to{
        border: solid 1px #303031;
        align-items: center;
        color: #000;
        text-decoration: none;
        white-space: nowrap;
    }
    .priority-cursor.el-dropdown-menu__item {
        cursor : not-allowed !important
    }
    .icon-direction {
        transform: translate(-60%,20%) scale(1) rotate(320deg);
        position: absolute;
    }
    .btn-new-save {
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color:#128807;
    }
    .move-to-visible{
        pointer-events: none;
        visibility: hidden;
        cursor: default!important;
    }
    .checkbox-hide {
        display:none !important;
    }
    .custom-checkbox.digi-checkbox {
		display: inline-flex !important;
		padding-right: 0px !important;
	}
    .icon-changes {
        width: 50%;
        border-left: 0.2px solid #cce3fc
    }
    .icon-div {
        border-radius: 20px;
        width: 5em;
        height: 1.5em;
        background-color: #f2f3f5;
    }
    .btn-discard {
        color:#005dae;
        line-height: 30px;
        border-radius: 5px;
        background-color:#fff;
    }
    .filterSelectedChips{
        background-color: #005dae !important;
        padding: 10px 10px 11px 10px !important;
        border-radius: 5px;
        margin-bottom: 5px;
    }
    .text-flow {
        max-width: 85px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        position: relative;
        top: 12px
    }
    .text-data {
        /* padding: 4px 8px !important; */
        border-radius: 20px;
        margin-right: 5px !important;
    }
    .text-data:before {
        content: "\eab5" !important;
        color: #00448b;
    }
    .custom__filter {
        display: inline-block;
        padding: 3px 12px;
        background: #fff;
        margin-right: 5px;
        border-radius: 16px;
        cursor: pointer;
        color: #00448b;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
		.scm-filters {
			width: 93% !important;
			top: 60px !important;
    		overflow: overlay !important;
			left: 24px !important;
		}
    }
	@media (min-width: 511px) and (max-width: 767px) {
		.scm-filters {
			width: 93% !important;
			top: 60px !important;
    		overflow: overlay !important;
			left: 24px !important;
		}
	}
    @media only screen and (max-width: 742px) {
        .margin742{
            margin-bottom: 10px !important;
        }
    }
    @media only screen and (max-width: 444px) {
        .margin444{
            margin-bottom: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Deals/ViewDeals.vue